// Fund forecast request label for dropdowns, e.g. "PPI-2 (Conduit Church) - 3 / 50 Families"
export const requestLabel = (req) => {
  const donor = req?.loan_donor?.name ? ` (${req.loan_donor.name})` : "";
  const count = req?.families_count ?? 0;
  const families = req?.requested_families
    ? `${count} / ${req.requested_families}`
    : `${count}`;

  return `${req?.rfq_id}${donor} - ${families} Families`;
};
